<div class="accordion">
  <div class="basic clickable" (click)="toggle()">
    <div class="header clickable">
      <span class="title clickable">{{
        data.groupingDate | date : 'MMM yyyy' : '' : 'en-US' | uppercase
      }}</span>
      <img
        src="../../../../../../assets/arrow-down-purple.svg"
        alt="arrow down"
        [@rotate]="isOpen ? 'rotated' : 'default'"
      />
    </div>
    <div class="costs">
      <div class="recorded">
        <span class="title clickable">{{
          'projectEstimate.payments.expenses.recordedCosts' | translate
        }}</span>
        <span class="number"
          >{{ projectBaseCurrency }}{{ data.recordedAmount | number }}</span
        >
      </div>
      <div class="budgeted">
        <span class="title clickable">{{
          'projectEstimate.payments.expenses.budgetedCosts' | translate
        }}</span>
        <span class="number"
          >{{ projectBaseCurrency }}{{ data.budgetedAmount | number }}</span
        >
      </div>
    </div>
  </div>
  <div class="accordion-content" [@openClose]="isOpen ? 'open' : 'closed'">
    <ng-container *ngFor="let costs of data | keyvalue : originalOrder">
      <div class="typeGroup" *ngIf="costTitles[costs.key] as title">
        <span class="type-group-title"> {{ title | translate }} </span>
        <div class="typeGroupItems">
          <div *ngFor="let item of costs.value" class="type-group-item">
            <div class="group">
              <span class="group-name">{{ getCostName(item) | translate }}</span>
              <div class="items">
                <div class="left">
                  <span class="left-name">{{
                    'projectEstimate.payments.expenses.paid' | translate
                  }}</span
                  ><span class="left-data"
                    >{{ projectBaseCurrency
                    }}{{ getPaidAmount(item) | number }}</span
                  >
                </div>
                <div class="right">
                  <span class="right-name">{{
                    'projectEstimate.payments.expenses.expected' | translate
                  }}</span
                  ><span class="right-data"
                    >{{ projectBaseCurrency
                    }}{{ getExpectedAmount(item) | number }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
